<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="ORIM-Dedication--Front-Matter-" id="_idParaDest-2"><a id="_idTextAnchor001"></a><i>To
					my Granddaughters Five:</i>
<br/><i>Lillian Rose, Violet Marie, Charlotte Elizabeth,</i>
<br/><i>Gretchen Jane, and Madeleine Elizabeth</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Goldsborough_TerrorAtTheFair_1P-2.vue?5849135b